var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"pending-icon",on:{"click":_vm.goToEntityList}},[_c('a-badge',{attrs:{"count":_vm.taskNumber,"offset":[20,6]}},[_c('Icon',{attrs:{"icon":"bell"}}),_vm._v(" "),_c('span',[_vm._v("待办")])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }